import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Resizable } from 'react-resizable';
import { Styled } from './Style';

class ResizableTitle extends Component {
    render() {
        const {
            onResize,
            width,
            minWidth,
            onClick,

            children,
            className,
            colSpan,
            onMouseEnter,
            onMouseLeave,
            rowSpan,
            style,
            isResizable,
        } = this.props;

        const thProps = {
            className,
            colSpan,
            onMouseEnter,
            onMouseLeave,
            rowSpan,
            style,
        };

        if (!isResizable || (width === null || width === undefined))
            return <th {...thProps} onClick={onClick}>{ children }</th>;

        return (
            <Resizable
                width={width}
                minConstraints={[minWidth, 0]}
                height={0}
                handle={
                    <span
                        className="resizable-title-handle"
                        onClick={e => e.stopPropagation()}
                    />
                }
                onResizeStart={() => {
                    this.resizing = true;
                }}
                onResizeStop={() => {
                    setTimeout(() => {
                        this.resizing = false;
                    });
                }}
                onResize={onResize}
                draggableOpts={{ enableUserSelectHack: false }}
            >

                <Styled
                    onClick={(...args) => {
                        if (!this.resizing && onClick)
                            onClick(...args);
                    }}
                    {...thProps}
                >
                    { children }
                </Styled>
            </Resizable>
        );
    }
}

export default connect(() => ({
}), {
})(ResizableTitle);
